// Module
var code = `<div class="ledger-units-content" ng-show="\$ctrl.supportsLedger">

  <table class="ledger-units-table table">
    <thead>
    <tr>
      <th>#</th>
      <th>Account</th>
      <th>Debit amount</th>
      <th>Credit amount</th>
      <th></th>
    </tr>
    </thead>
    <tbody>

    <tr>
      <td>1.</td>
      <td>
        <select disabled>
          <option>{{ \$ctrl.fixedAccountLabel }}</option>
        </select>
      </td>
      <td>
        <!-- Debit amount -->
        <cash ng-if="\$ctrl.entryType === 'DEBIT'"
          value="\$ctrl.amount"
          ng-disabled="true"></cash>
        <cash ng-if="\$ctrl.entryType === 'CREDIT'"
          ng-disabled="true"></cash>
      </td>
      <td>
        <!-- Credit amount -->
        <cash ng-if="\$ctrl.entryType === 'CREDIT'"
          ng-disabled="true"
          value="\$ctrl.amount"></cash>
        <cash ng-if="\$ctrl.entryType === 'DEBIT'"
          ng-disabled="true"></cash>
      </td>
      <td></td>
    </tr>

    <tr ng-repeat="unit in \$ctrl.userDefinedUnits">
      <td>{{\$index + 2}}.</td>
      <td>
        <account-select
            label-field="'label'"
            query-field="'accountCode'"
            value-field="'fullCode'"
            ng-model="unit"
            ng-disabled="\$ctrl.blocked"
            options="\$ctrl.ledgerAccounts"
            required
        >
        </account-select>
      </td>
      <td>
        <!-- Debit amount -->
        <cash ng-if="\$ctrl.entryType === 'CREDIT'"
              ng-model="unit.amount"
              ng-change="\$ctrl.onAmountChange()"
              ng-required="true">
        </cash>
        <cash ng-if="\$ctrl.entryType === 'DEBIT'"
              ng-disabled="true">
        </cash>
      </td>
      <td>
        <!-- Credit amount -->
        <cash ng-required="true"
              ng-if="\$ctrl.entryType === 'DEBIT'"
              ng-model="unit.amount"
              ng-change="\$ctrl.onAmountChange()">
        </cash>
        <cash ng-if="\$ctrl.entryType === 'CREDIT'"
              ng-disabled="true">
        </cash>
      </td>
      <td>
        <button type="button" class="btn btn-danger" ng-click="\$ctrl.removeUnit(unit)" ng-disabled="\$ctrl.blocked">Remove</button>
      </td>
    </tr>

    <tr class="add-account">
      <td></td>
      <td></td>
      <td>
        <cash value="\$ctrl.amount"
          ng-required="true"
          ng-disabled="true"
          min="0.01"></cash>
      </td>
      <td>
        <cash value="\$ctrl.amount"
          ng-required="true"
          ng-disabled="true"
          min="0.01"></cash>
      </td>
      <td>
        <button type="button" class="btn btn-success"
                ng-click="\$ctrl.addUnit()" ng-disabled="\$ctrl.blocked"
                ng-if="!\$ctrl.alwaysBlocked"
        >
          Add new
        </button>
      </td>
    </tr>

    </tbody>

  </table>

</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/ledger-units/ledger-units.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;